import {pages} from "./pages";
import menu from "../../components/layout/header/menu";
import routesNames from "./router";
import icons from "./icons/index";
import svgIcons from "./icons/svg-icons";
import images from "./images";
import roles from "./roles";
import permissions from "./permissions";
import index from "./breakpoints";
import {timesheetsStatusWorkerAsArray, timesheetsStatusApproverAsArray, timesheetsStatusAsArray, timesheetsStatus} from "./timesheets";

let allConstants = {};
allConstants.install = function (Vue) {
  Vue.prototype.$getConst = {
    routesNames,
    icons,
    breakpoints: index,
    pages,
    images,
    svgIcons,
    menu,
    roles,
    permissions,
    timesheetsStatus,
    timesheetsStatusAsArray,
    timesheetsStatusWorkerAsArray,
    timesheetsStatusApproverAsArray
  }
};

export default allConstants;
